import type { CSSProperties } from 'react';

/**
 * LoadingSpinner — minimal inline/full spinner.
 * Mirrors the Reports kit's ui/LoadingSpinner role (Suspense + query fallbacks).
 * Styling is plain inline CSS so the scaffold has no Tailwind build dependency;
 * swap to cdx-* utility classes once a Tailwind config is added.
 */
export function LoadingSpinner({ full = false, label = 'Loading' }: { full?: boolean; label?: string }) {
  const box: CSSProperties = full
    ? { minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }
    : { padding: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' };
  return (
    <div style={box} role="status" aria-live="polite">
      <span style={{ fontSize: 13, color: '#6B7A94', letterSpacing: '0.04em' }}>{label}&hellip;</span>
    </div>
  );
}
